var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.92308C0 3.09957 3.11956 0 6.96774 0C10.8159 0 13.9355 3.09957 13.9355 6.92308C13.9355 8.84037 12.9806 11.0531 11.7365 12.9983C10.4823 14.9591 8.86051 16.7626 7.38581 17.8615C7.13806 18.0462 6.79742 18.0462 6.54968 17.8615C5.07497 16.7626 3.45316 14.9591 2.19903 12.9983C0.954843 11.0531 0 8.84037 0 6.92308Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStart);
export default __webpack_public_path__ + "static/media/map-start.6994589eaf98f9668a03f0f437eabd5e.svg";
export { ForwardRef as ReactComponent };